import Logger from '../logging/logger';
import ReadMore from '../property/read-more';

function onPopupOpenDirectory( event: CustomEvent ) {
    const detail = event.detail || {};

    Logger.info( 'Event Triggered: onPopupOpenDirectory', detail );

    const container: HTMLElement | Document = detail.container || document;

    // Initialise Maps
    document.dispatchEvent( new CustomEvent( 'twc:init-map', {
        bubbles: true,
        detail: {
            container: container,
        },
    } ) );

    // Initialise "Read More" button
    const description = container.querySelector<HTMLElement>( '.directory-description' );

    if ( description && description.dataset.readMoreText ) {
        description[ 'readMore' ] = new ReadMore( description, {
            readMoreText: description.dataset.readMoreText,
            shortenClass: 'readmore-shorten',
            textLimit: 600,
        } );
    }
}

export default onPopupOpenDirectory;
